import { atom } from 'recoil';
import { EstimateList } from '../../../../../types/estimate/common/EstimateInfo';
import { INIT_LIST } from '../../../../../lib/initObj';
import { OtherBank } from '../../../../../types/estimate/common/OtherBank';

/**
 *  탭당 요청한 타금융사 할부 메이커금융 상품 목록
 *  */
export const otherBankMakerFinanceListState = atom<EstimateList<OtherBank>[]>({
  key: 'otherBankMakerFinanceList',
  default: INIT_LIST<OtherBank>(),
});
